export enum RegistrationFieldName {
  organization = 'organization',
  email = 'email',
  password = 'password',
  firstName = 'firstName',
  lastName = 'lastName',
  streetAddress1 = 'streetAddress1',
  streetAddress2 = 'streetAddress2',
  city = 'city',
  state = 'state',
  zipCode = 'zipCode',
  country = 'country',
  acceptedLegals = 'acceptedLegals',
  telephone = 'telephone',
  allowSms = 'allowSms',
  memberId = 'memberId',
  dateOfBirth = 'dateOfBirth',
  gender = 'gender',
  memberIdForCDPHP = 'memberIdForCDPHP',
  employeeId = 'employeeId',
  groupNumber = 'groupNumber',
  primaryFirstName = 'primaryFirstName',
  primaryLastName = 'primaryLastName',
  primaryDateOfBirth = 'primaryDateOfBirth',
  primaryGender = 'primaryGender',
  primaryMemberId = 'primaryMemberId',
  isPrimary = 'isPrimary',
  isDependent = 'isDependent',
}
